import { Organization, OrganizationScope } from '../types/support';

export const ORGANIZATIONS: Organization[] = [
    {
        id: '0196916d-52e9-7353-af52-4713a364d33a',
        name: 'Messdiener St. Marien Ahaus',
        description:
            'Die Messdiener St. Marien Ahaus sind eine lebendige Gemeinschaft junger Menschen, die sich aktiv in das kirchliche Leben der Pfarrgemeinde einbringen. Neben ihrem Dienst am Altar gestalten sie das Gemeindeleben durch regelmäßige Gruppenstunden, Ausflüge, soziale Aktionen und Ferienfreizeiten. Der Verein steht für Gemeinschaft, Engagement und den Glauben – mit Spaß, Verantwortung und Zusammenhalt.',
        website: 'https://messdiener-ahaus.de/',
        scope: OrganizationScope.Local
    }
];
